'use strict';

require('./rollbar');

require('babel-polyfill');

require('normalize.css/normalize.css');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createBrowserHistory = require('history/lib/createBrowserHistory');

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _asap = require('asap');

var _asap2 = _interopRequireDefault(_asap);

var _reactDom = require('react-dom');

var _reduxSimple = require('redux-simple');

var _gremlins = require('gremlins.js');

var _gremlins2 = _interopRequireDefault(_gremlins);

var _reactClicker = require('../utils/reactClicker');

var _index = require('../store/index');

var _App = require('../components/App/App');

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* injects from baggage-loader */

var history = (0, _createBrowserHistory2.default)();
var store = (0, _index.configureStore)(history);

(0, _asap2.default)(function () {
  (0, _reactDom.render)(_react2.default.createElement(
    _reduxSimple.Provider,
    { store: store },
    _react2.default.createElement(_App2.default, null)
  ), document.getElementById('mount'));
});

if (__DEV__) {
  window.store = store;
}

window.gremlins = function () {
  var nb = arguments.length <= 0 || arguments[0] === undefined ? 10000 : arguments[0];

  _gremlins2.default.createHorde().gremlin((0, _reactClicker.reactClicker)()).unleash({ nb: nb });
};


//////////////////
// WEBPACK FOOTER
// ./app/entryPoints/client.js
// module id = 621
// module chunks = 1